import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useUpdatePassword({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    currentPassword,
    newPassword,
  }: {
    currentPassword: string
    newPassword: string
  }) => {
    const response = await httpClient.put('auth/user/password', {
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: newPassword,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
    onSuccess: (res, variables) => {
      toast.success('Password updated successfully')
      // queryClient.invalidateQueries({ queryKey: ['current-user'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
